<template>
  <div class="chat-container">
    <!-- 左侧消息列表 -->
    <div class="chat-list">
      <div class="list-header">
        <div class="list-tabs">
          <span
            class="tab-item"
            :class="{ active: activeTab === 'all' }"
            @click="activeTab = 'all'"
            >全部</span
          >
          <span
            class="tab-item"
            :class="{ active: activeTab === 'unread' }"
            @click="activeTab = 'unread'"
            >未读</span
          >
        </div>
        <el-button
          type="text"
          class="filter-btn"
          @click="handleFilter"
          icon="el-icon-s-tools"
        >
          筛选
        </el-button>
      </div>
      <el-scrollbar class="list-content">
        <div
          class="list-item"
          v-for="item in filteredList"
          :key="item.id"
          :class="{ active: activeSessionId === item.id }"
          @click="handleSelectSession(item)"
        >
          <div class="avatar">
            <el-avatar :src="item.avatar" :size="40"></el-avatar>
          </div>
          <div class="item-content">
            <div class="item-title">{{ item.name }}</div>
            <div class="item-desc">{{ item.lastMsg }}</div>
          </div>
          <div class="item-meta">
            <span class="time">{{ item.time }}</span>
            <span
              class="star"
              :class="{ active: item.starred }"
              @click.stop="handleStar(item)"
              >★</span
            >
          </div>
        </div>
      </el-scrollbar>
    </div>

    <!-- 右侧聊天窗口 -->
    <div class="chat-window">
      <div class="window-header">
        <div class="user-info">
          <el-avatar :src="currentSession.avatar" :size="40"></el-avatar>
          <span class="username">{{ currentSession.name }}</span>
        </div>
      </div>
      <el-scrollbar class="window-content" ref="scrollRef">
        <div
          class="message-item"
          :class="{ 'message-right': item.type === 'right' }"
          v-for="(item, index) in messageList"
          :key="index"
        >
          <el-avatar
            :src="item.type === 'left' ? currentSession.avatar : userAvatar"
            :size="36"
            v-if="item.type === 'left'"
          ></el-avatar>
          <el-avatar
            :src="item.type === 'left' ? currentSession.avatar : userAvatar"
            :size="36"
            v-if="item.type === 'right'"
          ></el-avatar>
          <div
            class="message-bubble"
            :class="{
              back: item.type === 'left',
              back2: item.type === 'right',
            }"
          >
            <span class="message-text">{{ item.content }}{{ item.type }}</span>
          </div>
        </div>
      </el-scrollbar>
      <!-- 底部输入区域（核心修改） -->
      <div class="window-footer">
        <!-- 整体布局：左侧功能按钮 + 中间输入框 + 右侧发送按钮 -->
        <div class="footer-wrapper">
          <!-- 左侧竖向功能按钮 -->
          <div
            class="left-action-buttons"
            style="position: absolute; z-index: 9; top: -129px"
          >
            <el-button
              type="text"
              class="action-btn"
              icon="el-icon-s-tools"
              style="background-color: #348cf8; color: #fff; margin-left: 10px"
            ></el-button>
            <el-button
              style="background-color: #348cf8; color: #fff"
              type="text"
              class="action-btn"
              icon="el-icon-picture-outline"
            ></el-button>
            <el-button
              style="background-color: #348cf8; color: #fff"
              type="text"
              class="action-btn"
              icon="el-icon-folder-opened"
            ></el-button>
            <el-button
              style="background-color: #348cf8; color: #fff"
              type="text"
              class="action-btn"
              @click="handleAdd"
              icon="el-icon-plus"
            ></el-button>
          </div>

          <!-- 中间输入框区域 -->
          <div class="input-area">
            <el-input
              v-model="inputText"
              type="textarea"
              placeholder="Type a message here"
              class="message-input"
              :rows="1"
              :autosize="{ minRows: 1, maxRows: 4 }"
              @keyup.enter.native="handleSend"
              style="padding-left: 60px"
            ></el-input>
          </div>

          <!-- 右侧发送按钮区域 -->
          <div class="right-send-area">
            <el-button
              type="text"
              class="emoji-btn"
              icon="el-icon-smile"
            ></el-button>
            <el-button
              type="primary"
              class="send-btn"
              @click="handleSend"
              icon="el-icon-s-promotion"
              circle
            ></el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "privateMessageChat",
  props: {
    sessionList: {
      type: Array,
      default: () => [],
    },
    userAvatar: {
      type: String,
      default:
        "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png",
    },
  },
  data() {
    return {
      activeTab: "all",
      activeSessionId: null,
      inputText: "",
      messageList: [],
    };
  },
  computed: {
    filteredList() {
      if (this.activeTab === "unread") {
        return this.sessionList.filter((item) => item.unread > 0);
      }
      return this.sessionList;
    },
    currentSession() {
      return (
        this.sessionList.find((item) => item.id === this.activeSessionId) || {}
      );
    },
  },
  watch: {
    messageList: {
      handler() {
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      },
      deep: true,
    },
    activeSessionId() {
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
  },
  mounted() {
    if (this.sessionList.length > 0) {
      this.activeSessionId = this.sessionList[0].id;
      this.messageList = this.sessionList[0].messages || [];
    }
  },
  methods: {
    // 修复后的滚动到底部方法
    scrollToBottom() {
      if (this.$refs.scrollRef) {
        const scrollWrap = this.$refs.scrollRef.$el.querySelector(
          ".el-scrollbar__wrap",
        );
        if (scrollWrap) {
          scrollWrap.scrollTop = scrollWrap.scrollHeight;
        }
      }
    },
    handleFilter() {
      this.$emit("filter-click");
    },
    handleSelectSession(session) {
      this.activeSessionId = session.id;
      this.messageList = session.messages || [];
      this.$emit("session-select", session);
    },
    handleStar(item) {
      item.starred = !item.starred;
      this.$emit("star-change", item);
    },
    handleAdd() {
      this.$emit("add-click");
    },
    handleImage() {
      // 图片选择逻辑
      this.$emit("image-click");
      console.log("点击了图片按钮");
    },
    handleFile() {
      // 文件选择逻辑
      this.$emit("file-click");
      console.log("点击了文件按钮");
    },
    handleEmoji() {
      // 表情选择逻辑
      this.$emit("emoji-click");
      console.log("点击了表情按钮");
    },
    handleVideo() {
      // 视频选择逻辑
      this.$emit("video-click");
      console.log("点击了视频按钮");
    },
    handleVoice() {
      // 语音录制逻辑
      this.$emit("voice-click");
      console.log("点击了语音按钮");
    },
    handleSend() {
      if (!this.inputText.trim()) return;

      const newMsg = {
        type: "right",
        content: this.inputText.trim(),
        time: new Date().toLocaleTimeString(),
      };

      this.messageList.push(newMsg);
      this.$emit("message-send", {
        sessionId: this.activeSessionId,
        message: newMsg,
      });
      this.inputText = "";

      // 发送后再次触发滚动（确保生效）
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
  },
};
</script>

<style scoped>
.chat-container {
  display: flex;
  background-color: #f5f5f5;
  box-sizing: border-box;
  height: calc(100vh - 117px);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 30px;
  margin: 20px;
  background-color: #fff;
}

.chat-list {
  width: 320px;
  background-color: #fff;
  border-right: 1px solid #e6e6e6;
  display: flex;
  flex-direction: column;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  /* border-bottom: 1px solid #e6e6e6; */
}

.list-tabs {
  display: flex;
  gap: 20px;
}

.tab-item {
  font-size: 14px;
  color: #666;
  cursor: pointer;
  padding-bottom: 4px;
  border-bottom: 2px solid transparent;
}

.tab-item.active {
  color: #1989fa;
  font-weight: 600;
  border-bottom: 2px solid #1989fa;
}

.filter-btn {
  color: #666;
  font-size: 14px;
}

.list-content {
  flex: 1;
  height: calc(100% - 60px);
}

.list-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  /* border-bottom: 1px solid #f2f2f2; */
  cursor: pointer;
  transition: background-color 0.2s;
}

.list-item:hover {
  background-color: #f8f8f8;
}

.list-item.active {
  /* background-color: #f0f8ff; */
}

.list-item .avatar {
  margin-right: 12px;
}

.item-content {
  flex: 1;
  min-width: 0;
}

.item-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 4px;
  font-weight: 500;
}

.item-desc {
  font-size: 13px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.2;
}

.item-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.time {
  font-size: 12px;
  color: #999;
}

.star {
  font-size: 16px;
  color: #dcdcdc;
  cursor: pointer;
  transition: color 0.2s;
}

.star.active {
  color: #ffd04b;
}

.chat-window {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

.window-header {
  padding: 16px;
  /* border-bottom: 1px solid #e6e6e6; */
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.username {
  font-size: 16px;
  color: #333;
  font-weight: 600;
}

.window-content {
  flex: 1;
  padding: 20px;
  height: calc(100% - 180px);
}

.message-item {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;
}

.message-right {
  flex-direction: row-reverse;
}

.message-item .el-avatar {
  flex-shrink: 0;
}
.message-bubble.back {
  background-image: url("@/assets/chat.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 10px 24px;
}
.message-bubble.back2 {
  background-image: url("@/assets/chat2.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 10px 24px;
}
.message-bubble {
  max-width: 60%;
  padding: 10px 24px;
  margin: 0 12px;
  box-sizing: border-box;
}

.message-right .message-bubble {
  color: #323232;
}

.message-text {
  font-size: 15px;
  line-height: 1.4;
  word-break: break-all;
}

/* ========== 核心修改：window-footer 样式 ========== */
.window-footer {
  padding: 20px 16px; /* 调整内边距匹配图片 */
  border-top: 1px solid #e6e6e6;
  background-color: #fff;
  position: relative;
}

.footer-wrapper {
  display: flex;
  align-items: center;
  gap: 8px; /* 元素间距 */
}

/* 左侧竖向功能按钮 */
.left-action-buttons {
  display: flex;
  flex-direction: column; /* 竖向排列 */
  gap: 8px; /* 按钮间距 */
}

.left-action-buttons .action-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1989fa; /* 蓝色图标，匹配图片 */
  background-color: #f5f9ff; /* 浅蓝背景 */
  transition: all 0.2s;
  padding: 0; /* 清除默认内边距 */
}

.left-action-buttons .action-btn:hover {
  background-color: #e8f3ff;
  color: #0078e7;
}

/* 中间输入框区域 */
.input-area {
  flex: 1; /* 占满剩余宽度 */
}

.message-input {
  width: 100%;
  border-radius: 8px; /* 圆角匹配图片 */
  /* background-color: #f5f5f5; */
  /* border: 1px solid #e6e6e6; */
}

.message-input ::v-deep .el-textarea__inner {
  border-radius: 8px;
  border: none;
  background-color: transparent;
  padding: 8px 12px;
  resize: none;
  font-size: 14px;
  line-height: 1.4;
}

/* 右侧发送区域 */
.right-send-area {
  display: flex;
  align-items: center;
  gap: 8px;
}

.emoji-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  padding: 0;
}

.emoji-btn:hover {
  background-color: #f0f0f0;
}

.send-btn {
  width: 36px;
  height: 36px;
  padding: 0;
  /* border-color: #1989fa;
  background-color: #1989fa; */
}

.send-btn:hover {
  background-color: #0078e7;
  border-color: #0078e7;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
